import React, { useEffect, useState } from "react";
import "./home.css";
import { useKioskContext } from "../../store/Context";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { drugTestCheckIn } from "../../Api/API";
import Loader from "../loader/Loader";

const Home = () => {
  const { setCurrentScreen, restart, text, isTippecanoe } = useKioskContext();
  console.log("isTippecanoe",isTippecanoe)

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const showDrugTestCheckIn = localStorage.getItem("showDrugTest") === "true";

  const participantName = localStorage.getItem("participantName") || "";

  useEffect(() => {
    setCurrentScreen(3);
  }, [setCurrentScreen]);

  const handleClick = async (type) => {
    if (loading) return;

    if (type === "report") {
      navigate("/questions");
      return;
    }

    if (type === "drugtest") {
      setLoading(true);

      try {
        const { data, error } = await drugTestCheckIn();

        if (error || !data?.success) {
          toast.error(error || text.somethingWentWrong, { toastId: "error" });
          return;
        }

        setCurrentScreen(5);
        navigate("/feedback");
      } catch (error) {
        console.error("Drug Test Check-In error:", error);

        toast.error(text.somethingWentWrong, {
          toastId: "error",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="home-container">
      {loading && <Loader />}

      <div>
        <h1 className="heading">
          {text.homeText} {participantName}
        </h1>
      </div>

      <div className="home-btn-container">
        {!isTippecanoe && (
          <button
            onClick={() => handleClick("report")}
            className="home-btn"
            disabled={loading}
          >
            {text.repostBtn}
          </button>
        )}

        {showDrugTestCheckIn && (
          <button
            onClick={() => handleClick("drugtest")}
            className="home-btn"
            disabled={loading}
          >
            {text.drugTest}
          </button>
        )}

        <button className="restart-btn" onClick={restart} disabled={loading}>
          {text.restart}
        </button>
      </div>
    </div>
  );
};

export default Home;
